<!-- 下载任务 -->
<template>
<div>
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">下载任务</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">任务类型</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择任务类型"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(value,key) in selectData.type" :key="key" :value="key">
					  {{value}}
					</a-select-option>
					
				</a-select>
			</div>
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">状态</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择状态"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(value,key) in selectData.status" :key="key" :value="key">
					  {{value}}
					</a-select-option>
					
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
		</div>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
		<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
			<div class="table-th-cell" style="cursor: default;" 
			:style="{'width':rableTitle[0].width + 'px'}" >
				{{rableTitle[0].title}}
			</div>
			<div class="table-th-cell" style="cursor: default;"
			:style="{'width':rableTitle[1].width + 'px'}" >
				{{rableTitle[1].title}}
			</div>
			
		</div>
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
		
			<div v-if="index > 1" class="table-th-cell" 
			:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
			@click="sortClick(index)">
				{{item.title}}
			</div>
		</div>
		<!-- 占位，隔出一个空白区域 -->
		<div id="" style="padding:15px;"></div>
	</div>
	
	
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			
				<div  class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					{{item.type}}
				</div>
			
		</div>
		
		<!-- 创建时间 -->
		<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
			{{item.created_at}}
		</div>
		<!-- 任务创建者 -->
		<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
			{{item.admin_name}}
		</div>
		<!-- 状态 -->
		<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
			{{item.status_text}}
		</div>
		<!-- 任务进度 -->
		<div class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}">
			{{item.perform_num}}/{{item.perform_total}}
		</div>
		<!-- 备注 -->
		<div class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}">
			<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
				{{item.remark}}
			</div>
		</div>
		<!-- 操作 -->
		<div class="table-td-cell" :style="{'width': rableTitle[7].width + 'px'}" style="display: flex;flex-wrap: wrap;">
			
			<div v-if="item.status == 2" @click="downButton(item)" style="color: #62a8ea;cursor: pointer;margin-right: 11px;">下载</div>
			
			
		</div>
		
		
		
	</div>
	
	
	<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	
	
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_scroll_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	</div>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
	
import { downTaskList,  bookInfo,  putDataMenu, downTaskSelect } from '@/request/api'
export default {
	name: 'downTask_',
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			table_scroll_width: 2600,
			
			r_limit: 50,
			r_page: 1,
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			r_gzh_id: "", // 公众号
			r_applets_id: "", // 小程序
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:80, sort_status:0, type:"id",sort_control: false, }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"任务类型",width:180, sort_status:0, type:"type",sort_control: false,},
				{title:"创建时间",width:180, sort_status:0, type:"created_at",sort_control: false, },
				{title:"任务创建者",width:150, sort_status:0, type:"admin_name",sort_control: false, },
				{title:"状态",width:120, sort_status:0, type:"status_text",sort_control: false, },
				{title:"任务进度",width:120, sort_status:0, type:"perform_num、perform_total",sort_control: false, },
				{title:"备注",width:200, sort_status:0, type:"remark",sort_control: false, },
				{title:"操作",width:100, sort_status:0, type:"cz",sort_control: false,},
				
			],
			tableShowData: [],
			
			search_button_loading: false, // 搜索按钮的加载状态
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			
			visible: false,
			// 新增侧边栏
			x_book_name: "", // 作品名称
			x_roi: "", // 首日ROI目标(%)
			x_book_type: undefined, // 频道
			x_category: undefined, // 分类
			x_id: "", // id
			add_form_hint: "", // 侧边栏新增表单的验证提示
			categoryManList: [], // 男频的分类选择
			categoryWomanList: [], // 女频的分类选择
			categoryShowList: [], // 分类的显示
			drawer_title: "", // 侧边栏标题
			table_total: 0, // 表格内容总数
			
			body_width: 1800, // body的宽度
			
			selectData: {
				status: {},
				type: {}
			},
			r_type: "", // 任务类型
			r_status: "", // 状态
		}
	},
	mounted(){
		let that = this
		that.body_width = document.body.clientWidth - 60
		console.log("that.body_width",that.body_width);
		
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		console.log(that.table_scroll_width)
		
		
		downTaskSelect().then(res=>{
			console.log("获取筛选条件",res);
			that.selectData = res.data.data
		})
		
		
		
		that.searchButton()
		
	},
	methods:{
		// 单个日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			
			this.endTime = dateString
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 请选择任务类型
		handleChangeA(e){
			console.log(e);
			this.r_type = e
		},
		// 选择状态
		handleChangeC(e){
			console.log(e);
			this.r_status = e
		},
		// 新增侧边栏-频道
		handleChangek(value){
			console.log(value)
			
			if(value == 1){
				this.categoryShowList = this.categoryManList
			}
			else if(value == 2){
				this.categoryShowList = this.categoryWomanList
			}
			else {
				this.categoryShowList = []
			}
			this.x_book_type = value
			this.x_category = undefined // 重置分类内容
		},
		// 新增侧边栏-分类
		handleChangeL(value){
			this.x_category = value
		},
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				type: that.r_type, // 任务类型
				status: that.r_status, // 状态
			}
			
			downTaskList(r_data).then(res=>{
				console.log("搜索结果",res)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
		},
		
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.searchButton()
		},
		
		
		downButton(item){
			console.log(item);
			
			window.open('https://'+item.url, '_blank')
			// window.open('https://wx-admin.test.gzlize.com/exports/35da5d0cf929ff30ec9485e1310f86cc.csv', '_blank')
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		
	}
}
</script>

<style scoped>
	
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}


</style>